/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Talk_Action_PhraseInputs */

const en_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`start a call`)
};

const id_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mulai panggilan`)
};

const ms_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mulakan panggilan`)
};

const ca_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iniciar una trucada`)
};

const cs_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zahájit hovor`)
};

const da_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`begynd et opkald`)
};

const de_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen Anruf starten`)
};

const et_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alusta kõnet`)
};

const es_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iniciar una llamada`)
};

const fr_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`démarrer l’appel`)
};

const hr_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`započnite poziv`)
};

const it_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia una chiamata`)
};

const lv_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sākt zvanu`)
};

const lt_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pradėti skambutį`)
};

const hu_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hívás indítása`)
};

const nl_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`begin een gesprek`)
};

const nb_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`start en samtale`)
};

const pl_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rozpocznij połączenie`)
};

const pt_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iniciar chamada`)
};

const ro_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inițiază un apel`)
};

const sk_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`začať hovor`)
};

const sl_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`začnite klic`)
};

const fi_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aloita puhelu`)
};

const sv_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`starta samtal`)
};

const vi_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bắt đầu cuộc gọi`)
};

const tr_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bir görüşme başlat`)
};

const el_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`έναρξη κλήσης`)
};

const bg_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`започни разговор`)
};

const ru_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`начать звонок`)
};

const sr_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`започните разговор`)
};

const uk_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`почати дзвінок`)
};

const ka_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ზარის დაწყება`)
};

const hi_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉल शुरू करें `)
};

const th_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มการโทร`)
};

const ko_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`통화 시작`)
};

const zh_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始通话`)
};

const zh_tw_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始通話`)
};

const ja_talk_action_phrase = /** @type {(inputs: Talk_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話を開始`)
};

/**
* | output |
* | --- |
* | "start a call" |
*
* @param {Talk_Action_PhraseInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const talk_action_phrase = /** @type {((inputs?: Talk_Action_PhraseInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Talk_Action_PhraseInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_talk_action_phrase(inputs)
	if (locale === "ms") return ms_talk_action_phrase(inputs)
	if (locale === "ca") return ca_talk_action_phrase(inputs)
	if (locale === "cs") return cs_talk_action_phrase(inputs)
	if (locale === "da") return da_talk_action_phrase(inputs)
	if (locale === "de") return de_talk_action_phrase(inputs)
	if (locale === "et") return et_talk_action_phrase(inputs)
	if (locale === "es") return es_talk_action_phrase(inputs)
	if (locale === "fr") return fr_talk_action_phrase(inputs)
	if (locale === "hr") return hr_talk_action_phrase(inputs)
	if (locale === "it") return it_talk_action_phrase(inputs)
	if (locale === "lv") return lv_talk_action_phrase(inputs)
	if (locale === "lt") return lt_talk_action_phrase(inputs)
	if (locale === "hu") return hu_talk_action_phrase(inputs)
	if (locale === "nl") return nl_talk_action_phrase(inputs)
	if (locale === "nb") return nb_talk_action_phrase(inputs)
	if (locale === "pl") return pl_talk_action_phrase(inputs)
	if (locale === "pt") return pt_talk_action_phrase(inputs)
	if (locale === "ro") return ro_talk_action_phrase(inputs)
	if (locale === "sk") return sk_talk_action_phrase(inputs)
	if (locale === "sl") return sl_talk_action_phrase(inputs)
	if (locale === "fi") return fi_talk_action_phrase(inputs)
	if (locale === "sv") return sv_talk_action_phrase(inputs)
	if (locale === "vi") return vi_talk_action_phrase(inputs)
	if (locale === "tr") return tr_talk_action_phrase(inputs)
	if (locale === "el") return el_talk_action_phrase(inputs)
	if (locale === "bg") return bg_talk_action_phrase(inputs)
	if (locale === "ru") return ru_talk_action_phrase(inputs)
	if (locale === "sr") return sr_talk_action_phrase(inputs)
	if (locale === "uk") return uk_talk_action_phrase(inputs)
	if (locale === "ka") return ka_talk_action_phrase(inputs)
	if (locale === "hi") return hi_talk_action_phrase(inputs)
	if (locale === "th") return th_talk_action_phrase(inputs)
	if (locale === "ko") return ko_talk_action_phrase(inputs)
	if (locale === "zh") return zh_talk_action_phrase(inputs)
	if (locale === "zh-tw") return zh_tw_talk_action_phrase(inputs)
	if (locale === "ja") return ja_talk_action_phrase(inputs)
	return en_talk_action_phrase(inputs)
});